import { render, staticRenderFns } from "./editCoins.vue?vue&type=template&id=236076e3&scoped=true&"
import script from "./editCoins.vue?vue&type=script&lang=js&"
export * from "./editCoins.vue?vue&type=script&lang=js&"
import style0 from "./editCoins.vue?vue&type=style&index=0&id=236076e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236076e3",
  null
  
)

export default component.exports